import * as React from 'react';

import './styles/Swatch.scss';

export type SwatchColors = 'caribbean' | 'sky' | 'brand' | 'midnight' | 'violet';

type Props = {
  color: SwatchColors,
};

function Swatch(props: Props) {
  return <div className={`Swatch Swatch--${props.color}`} aria-hidden />;
}

export default Swatch;
